const page = "payment-information";

export const medicationInfoMap: Record<
  string,
  { name: string; header: string; text?: string; dosage?: string }
> = {
  st: {
    name: "Semaglutide",
    header: `${page}.st.header`,
    text: `${page}.st.text`,
  },
  tr: {
    name: "Tirzepatide",
    header: `${page}.tr.header`,
    text: `${page}.tr.text`,
  },
  mt: {
    name: "Metformin",
    header: `${page}.mt.header`,
    text: `${page}.mt.text`,
  },
  "st-ot": {
    name: "Semaglutide",
    header: `${page}.st.header`,
    text: `${page}.st.text`,
  },
  "tr-ot": {
    name: "Tirzepatide",
    header: `${page}.tr.header`,
    text: `${page}.tr.text`,
  },
  "fhl-oral": {
    name: "Complete Hair Growth Pack",
    header: `${page}.fhl-pill.header`,
  },
  "fhl-dropper": {
    name: "Rapid Regrowth Serum",
    header: `${page}.fhl-serum.header`,
  },
  on: {
    name: "Ondansetron",
    header: `${page}.on.header`,
    text: `${page}.on.text`,
  },
  bc: {
    name: "Birth Control",
    header: `${page}.bc.header`,
  },
  "bc-ot": {
    name: "Birth Control",
    header: `${page}.bc-ot.header`,
  },
  ec: {
    name: "Emergency Contraception",
    header: `${page}.ec.header`,
  },
  "mhl-ot-oral": {
    name: "Complete Hair Growth Pack",
    header: `${page}.mhl-ot-oral.header`,
  },
  "mhl-ot-topical": {
    name: "Rapid Regrowth Serum",
    header: `${page}.mhl-ot-topical.header`,
  },
  "fhl-ot-oral": {
    name: "Complete Hair Growth Pack",
    header: `${page}.fhl-pill.header`,
  },
  "fhl-ot-dropper": {
    name: "Rapid Regrowth Serum",
    header: `${page}.fhl-serum.header`,
  },
  "ed-ot-boss+(sildenafil)": {
    name: "Sildenafil",
    header: `${page}.ed-ot-boss+.header`,
    text: `${page}.ed-ot-boss+.sildenafil.text`,
    dosage: "36 mg",
  },
  "ed-ot-boss+(tadalafil)": {
    name: "Tadalafil",
    header: `${page}.ed-ot-boss+.header`,
    text: `${page}.ed-ot-boss+.tadalafil.text`,
    dosage: "6 mg",
  },
  "ed-ot-boss max": {
    name: "Boss Max",
    header: `${page}.ed-ot-boss-max.header`,
    text: `${page}.ed-ot-boss-max.text`,
    dosage: "55mg + 12.5mg",
  },
  "amh-ot": {
    name: "Fresh Start Pack",
    header: `${page}.amh-ot.header`,
    text: `${page}.amh-ot.text`,
  },
  "aa-ot": {
    name: "Radiance Renewal Cream",
    header: `${page}.aa-ot.header`,
    text: `${page}.aa-ot.text`,
  },
  "ac-ot": {
    name: "Clear Skin Cream",
    header: `${page}.ac-ot.header`,
    text: `${page}.ac-ot.text`,
  },
  "b-ot": {
    name: "Biotin",
    header: `${page}.b-ot.header`,
    text: `${page}.b-ot.text`,
  },
  "ro-ot": {
    name: "Redness Relief Cream",
    header: `${page}.ro-ot.header`,
    text: `${page}.ro-ot.text`,
  },
  "bb-ot": {
    name: "Beta Blocker Pack",
    header: `${page}.bb-ot.header`,
    text: `${page}.bb-ot.text`,
  },
  "sl-ot": {
    name: "Sleep Support Pack",
    header: `${page}.sl-ot.header`,
    text: `${page}.sl-ot.text`,
  },
  "iwl-ot": {
    name: "GLP-1 Weight Loss Medication",
    header: `${page}.iwl-ot.header`,
  },
  "wp-ot": {
    name: "Wegovy Pills",
    header: `${page}.wp-ot.header`,
  },
  "os-ot": {
    name: "Oral Semaglutide",
    header: `${page}.os-ot.header`,
  },
  "db-ot": {
    name: "Metformin",
    header: `${page}.mt.header`,
    text: `${page}.db-ot.text`,
  },
  "cv-ot": {
    name: "Atorvastatin",
    header: `${page}.cv-ot.header`,
    text: `${page}.cv-ot.text`,
  },
};
